


<iframe [src]="quotationPdfPreviewUrl" style="width:100%;height:800px"></iframe>

<button type="button" class="btn btn-metal arrangecancelbutton" style="float: right;margin-right: 15px; margin-bottom: 5px;"
(click)="closePopup()">Cancel</button>


